import { useCallback, useEffect, useRef, useState } from 'react';
import { uuid } from '@/utils';
import { fetchBeginUploadDoorlock, fetchEndUploadDoorlock } from '@/api/card';

// 1:制房卡弹窗,2:更新房卡弹窗,3:读房卡弹窗,4:退房卡弹窗
export enum CardUsage {
  Create = 1,
  Update = 2,
  Read = 3,
  Check = 4,
}
type TStartParams = { type: CardUsage; roomNo?: string };

// 1成功，2失败，3超时无结果
export enum UploadStatus {
  Success = 1,
  Fail = 2,
  Timeout = 3,
}
type TEndParams = { result: UploadStatus; remark?: string; roomNo?: string };

interface IUploadReturnType {
  id: string;
  startUploadDoorInfo: (info?: TStartParams) => Promise<any>;
  endUploadDoorInfo: (info?: TEndParams) => Promise<any>;
}

const useUploadDoorLock: () => IUploadReturnType = () => {
  const idRef = useRef<string>('');

  const startUploadDoorInfo = useCallback((info?: TStartParams) => {
    const tempId = uuid();
    idRef.current = tempId;

    return fetchBeginUploadDoorlock({
      businessKey: tempId,
      ...info,
    });
  }, []);

  const endUploadDoorInfo = useCallback((info?: TEndParams) => {
    return fetchEndUploadDoorlock({
      businessKey: idRef.current,
      ...info,
    })
      .then(() => {
        // 重新生成ID
        const tempId = uuid();
        idRef.current = tempId;
      })
      .catch(() => {
        //
      });
  }, []);

  return {
    id: idRef.current,
    startUploadDoorInfo,
    endUploadDoorInfo,
  };
};

export default useUploadDoorLock;
